window.console || (window.console = {
	log: function(){}
});
var DIPUNTO = window.DIPUNTO || null;
var cssua = window.cssua || null;

(function($) {
	const htmlHasClass = (_class) => {
		return $('html').hasClass(_class);
	};
	const siteName = '';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';

	DIPUNTO = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			},
			header: {
				desktop: 80,
				sp: 60
			}
		},
		localDecision() {
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() {
			let _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			let key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);
			let includeClassLen = includeClass.length;

			for (let i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (let i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done((...args) => {
					let regExp = new RegExp(key);

					if (args[1] === 'success') { // includeが1個だけの場合
						let position = $(args[0]).filter(':first').attr('class').split(' ');
						for (let j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (let i = 0; i < args.length; i++) {
							let result = args[i];
							let position = $(result[0]).filter(':first').attr('class').split(' ');

							for (let j = 0; j < position.length; j++) {
								if (position[j].match(regExp)) {
									position = position[j];
									break;
								}
							}
							$('.' + position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (let i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle() {
			let $switch = $('.js-toggle');

			$switch.on('click', (e) => {
				$(e.currentTarget).toggleClass(a);
				$(e.currentTarget).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュに基づいてタブを切り替え
				const switchTabByHash = () => {
					if (location.hash) {
						let hash = location.hash.split('#')[1];
						$tab.forEach(tab => {
							tab.classList.remove(a);
							tab.ariaSelected = false;
							if (tab.getAttribute('data-target').match(hash)) {
								tab.classList.add(a);
								tab.ariaSelected = true;
							}
						});
						$content.forEach(ele => {
							ele.classList.remove(a);
							ele.classList.remove(v);
							if (ele.getAttribute('data-target').match(hash)) {
								ele.classList.add(a);
								setTimeout(() => { ele.classList.add(v); }, 200);
							}
						});
					}
				};

				// 初期化時にハッシュをチェック
				switchTabByHash();

				// ハッシュ変更時にもタブを切り替え
				window.addEventListener('hashchange', switchTabByHash);

				$tab.forEach(ele => {
					ele.addEventListener('click', () => {
						$tab.forEach(tab => {
							tab.classList.remove(a);
							tab.ariaSelected = false;
						})
						ele.classList.add(a);
						ele.ariaSelected = true;

						$content.forEach(content => {
							content.classList.remove(a);
							content.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll('[data-target="' + target + '"]');
						}
						$target.forEach(target => {
							target.classList.add(a);
							setTimeout(() => { target.classList.add(v); }, 200);
						});
					});
				});
			}
		},
		easeScroll() {
			$('a[rel="scroll"]').on('click', (event) => {
				if (/#/.test(event.currentTarget.href)) {
					let speed = 1200;
					scrollToObject(event, speed);
					return false;
				}
			});
			function scrollToObject(_self, _speed) {
				let hash = '#' + _self.currentTarget.href.split('#')[1];
				let pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (DIPUNTO.va.window.width < DIPUNTO.va.device.sp) {
						pos -= DIPUNTO.va.header.sp;
					} else {
						pos -= DIPUNTO.va.header.desktop;
					}
				}

				// lazyloadとの併用のための記述
				$.when(
					$('html, body').animate({ scrollTop: pos }, _speed, 'easeOutExpo'),
				).done(() => {
					if (hash !== '#pagetop') {
						let diff = $(hash).offset().top;
						if(DIPUNTO.va.window.width < DIPUNTO.va.device.sp) {
							diff -= DIPUNTO.va.header.sp;
						} else {
							diff -= DIPUNTO.va.header.desktop;
						}
						if (diff !== pos) {
							$('html, body').animate({ scrollTop: diff }, 10, 'easeOutExpo');
						}
					}
				});
			}
		},
		easeScrollHash() {
			const hash = location.hash;
			const speed = 1200;
			if (hash) {
				$(window).on('load', () => {
					$('html, body').css('display', 'none');

					setTimeout(() => {
						$('html, body').css('display', 'block');

						let _hash = '#' + hash.split('#')[1];
						if (!$(_hash).length) return;
						let pos = $(_hash).offset().top;

						if (DIPUNTO.va.window.width < DIPUNTO.va.device.sp) {
							pos -= DIPUNTO.va.header.sp;
						} else {
							pos -= DIPUNTO.va.header.desktop;
						}
						$('html, body').stop().animate({ scrollTop: pos }, speed, 'easeOutExpo');
					}, 100);
				});
			}
		},
		scrollEvent() {
			if($('.company-franchise-btn').length) {
				var $btn = $('.company-franchise-btn');
				$(window).scroll((e) => {
					var $footer = $('footer');
					var footerPos = $footer.offset().top;
					var $this = $(e.currentTarget);
					var thisScroll = $this.scrollTop() + $(window).height();
					if (thisScroll < footerPos) {
						$btn.addClass(v);
					} else {
						$btn.removeClass(v);
					}
				});
			}
		},
		pageTop() {
			const $pagetop = document.querySelector('.footer-pagetop');

			if ($pagetop) {
				// SP: 750px、PC: 1280px でトリガー
				const threshold = DIPUNTO.va.window.width < DIPUNTO.va.device.sp ? 750 : 1280;

				// ページ上部領域の監視（閾値以内は非表示、それより下で表示）
				const optionsTop = {
					root: null,
					rootMargin: `${threshold}px 0px ${document.body.clientHeight}px 0px`,
					threshold: 1
				};

				const callbackTop = (entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							// 上部領域内 → 非表示
							$pagetop.classList.remove(v);
						} else {
							// 上部領域外（下にスクロール）→ 表示
							$pagetop.classList.add(v);
						}
					});
				};

				const observerTop = new IntersectionObserver(callbackTop, optionsTop);
				observerTop.observe(document.body);

				// フッター領域の監視（フッターに達したらis-bottom追加）
				const $footerNav = document.querySelector('.footer-nav');
				if ($footerNav) {
					const callbackBottom = (entries, observer) => {
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								$pagetop.classList.add('is-bottom');
							} else {
								$pagetop.classList.remove('is-bottom');
							}
						});
					};

					const observerBottom = new IntersectionObserver(callbackBottom, {});
					observerBottom.observe($footerNav);
				}
			}
		},
		modal() {
			$('.mod-modal').on('click', (e) => {
				let HTML = '<div class="mod-modal-overlay">';
				HTML +=
					'<div class="mod-modal-closeArea"></div>'+
					'<span class="mod-modal-closeBtn"><span></span></span>' +
					`${$(e.currentTarget).find('img').prop('outerHTML')}</div>`;
				$('body').append(HTML);

				const $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
			$('.mod-modal-youtube').on('click', (e) => {
				let HTML = '<div class="mod-modal-youtube-overlay">';
				HTML +=
					'<div class="mod-modal-youtube-closeArea"></div>'+
					'<span class="mod-modal-youtube-closeBtn"><span></span></span>' +
					`<div class="mod-modal-youtube-content"><div class="mod-youtube"><iframe width="560" height="315" src="https://www.youtube.com/embed/${$(e.currentTarget).data('id')}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div></div>`+
					'</div>';
				$('body').append(HTML);
				const $overlay = $('.mod-modal-youtube-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-youtube-closeArea, .mod-modal-youtube-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload() {
			if ($('.js-lazy-img').length) {
				$('.js-lazy-img').lazyload();
			}
		},
		setImgAttrWidthHeight() {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => {
						resolve(image);
					}
					image.onerror = (error) => {
						reject(error);
					}
				});
			};

			const imgs = document.getElementsByTagName('img');

			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		headerMenu() {
			if($('.header-menu').length) {
				const $menu = $('.header-menuWrap');
				const $menuBtn = $('.header-menuBtn');
				const $menuLink = $('.header-menu-list-item-a, .header-shop-item-a');

				$menuBtn.on('click', (e) => {
					$menuBtn.toggleClass(a);
					$menu.toggleClass(a);
				});

				$menuLink.on('click', (e) => {
					$menuBtn.removeClass(a);
					$menu.removeClass(a);
				});

				// SPメニューのフォーカス管理
				const setupSPMenuFocusControl = () => {
					// SPメニュー内にフォーカスがあるかどうか
					const isInsideSPMenu = (element) => {
						return $menu.find(element).length > 0 || $(element).is($menuBtn);
					};

					// フォーカスが外れた時の処理
					$menu.on('focusout', function(e) {
						setTimeout(() => {
							const focusedElement = document.activeElement;
							if (!isInsideSPMenu(focusedElement)) {
								$menuBtn.removeClass(a);
								$menu.removeClass(a);
								$menuBtn.focus();
							}
						}, 0);
					});

					// Escキーで閉じる
					$menu.on('keydown', function(e) {
						if (e.key === 'Escape') {
							$menuBtn.removeClass(a);
							$menu.removeClass(a);
							$menuBtn.focus();
						}
					});
				};
				setupSPMenuFocusControl();
			};
		},
		headerFixed() {
			if($('.header-menu').length) {
				const header = document.querySelector('.header');
				const mainVisual = document.querySelector('.mainVisual');

				if (!header || !mainVisual) return;

				let lastScrollY = window.scrollY;
				let headerShownOnce = false;

				const updateHeader = () => {
					const mainVisualHeight = mainVisual.offsetHeight;
					const mainVisualHalfPoint = mainVisualHeight / 2;
					const scrollingUp = window.scrollY < lastScrollY;
					lastScrollY = window.scrollY;

					if (headerShownOnce) {
						// 一度でも表示されたら以降は常に表示のまま
						if (header.classList.contains(a)) {
							header.classList.remove(a);
						}
						return;
					}

					if (window.scrollY >= mainVisualHalfPoint || scrollingUp) {
						// MVの真ん中を通過 or 上スクロール → ヘッダー表示
						header.classList.remove(a);
						headerShownOnce = true;
					} else {
						// MV上半分表示中 → ヘッダー非表示
						header.classList.add(a);
					}
				};

				header.classList.add(a);
				window.addEventListener("scroll", updateHeader);
			};
		},
		headerCurrent() {
			// ヘッダーグロナビのカレント表示
			if ($('.header-menu-list-item-a').length) {
				$('.header-menu-list-item-a').each((idx, val) => {
					if (location.pathname.indexOf($(val).attr('href').replace('index.html', '')) != -1) {
						$(val).addClass(a);
					}
				});
			}
		},
		formAnswer() {
			// フォームの回答希望欄の選択
			function setEmailInactive() {
				if($('[value=希望する]').prop('checked')){
					$(".js-e_mail").removeClass("inactive")
				} else if ($('[value=希望しない]').prop('checked')) {
					$(".js-e_mail").addClass("inactive")
				}
			}

			setEmailInactive()
			$('[name="answer_desired"]:radio').change( function() {
				setEmailInactive()
			});
		},
		formYear() {
			// フォームの年のプルダウン設定
			if ($('.contact-day-select-year').length) {
				const year = new Date().getFullYear()
				let HTML = '';
				for (let i = 0; i < 3; i++) {
					HTML += '<option value="'+ (year - i) + '">' + (year - i) + '</option>'
				}
				$('.contact-day-select-year').append(HTML);

				const yearValue = $('[name="visit_year2"]').val()
				if (yearValue) {
					$('[name="visit_year"]').val(yearValue)
				}else {
					$('[name="visit_year"]').val('-')
				}
			}
		},
		formReset() {
			// フォームのクリアボタンでで初期値を入れる
			if ($('.js-form_reset').length) {
				$('.js-form_reset').on('click', function () {
					$('[name="store_type"]:radio').prop('checked', false)
					$('[name="store_details"]:text').val('')
					$('[name="visit_year"]').val('-')
					$('[name="visit_month"]').val('-')
					$('[name="visit_day"]').val('-')
					$('[name="visit_time"]').val('-')
					$('[name="question"]').val('')
					$('[name="answer_desired"]:radio').prop('checked', false)
					$('[name="answer_desired"]:radio').val('希望しない').prop('checked', true)
					$('.js-e_mail').addClass("inactive")
					$('[name="email"]:text').val('')
					$('[name="email2"]:text').val('')
					$('[name="inquirer_name"]:text').val('')
					$('[name="agree"]:checkbox').val('').prop("checked", false)
				})
			}
		},
		formConfirm() {
			// フォームの内容確認でメールアドレスの必須を表示非表示する
			if ($('.js-emailRequired').length) {
				if ($('.js-emailRequiredKey').text() === '希望しない') {
					$('.js-emailRequired').css('display','none');
				}
			}
		},
		newsYear() {
			// ニュースの年のプルダウン設定
			if ($('.js-news-latest-year').length) {
				const pagePath = location.pathname;
				const checkDrinkPattern = /^\/dipunto\/topics\/.*drink\/$/;
				const checkFoodPattern = /^\/dipunto\/topics\/.*food\/$/;
				const checkCampaignPattern = /^\/dipunto\/topics\/.*campaign\/$/;
				let pathHead = '';
				let pathEnd = '';
				let displayedResults = 20;	//表示件数

				if (checkDrinkPattern.test(pagePath)) {
					pathHead = '/dipunto/topics/';
					pathEnd = 'drink/'
					displayedResults = 6	//表示件数を6件に変更
				}else if (checkFoodPattern.test(pagePath)) {
					pathHead = '/dipunto/topics/';
					pathEnd = 'food/'
					displayedResults = 6	//表示件数を6件に変更
				}else if (checkCampaignPattern.test(pagePath)) {
					pathHead = '/dipunto/topics/';
					pathEnd = 'campaign/'
					displayedResults = 6	//表示件数を6件に変更
				}else if (pagePath.indexOf('/topics/') != -1) {
					pathHead = '/dipunto/topics/';
					displayedResults = 6	//表示件数を6件に変更
				}else if (pagePath.indexOf('/news/') != -1) {
					pathHead = '/dipunto/news/';
				}

				// optionを追加
				const latestYear = Number($('.js-news-latest-year').text());
				const numberOfYears = latestYear - Number($('.js-news-earliest-year').text()) + 1;
				let HTML = '<option value="'+ pathHead + pathEnd +'">最新' + displayedResults +'件</option>';
				for (let i = 0; i < numberOfYears; i++) {
					HTML += '<option value="'+ pathHead + (latestYear - i) + '/' + pathEnd + '">' + (latestYear - i) + '</option>'
				}
				$('.js-news-select-year').append(HTML);

				// 見ている年をselected
				$('.js-news-select-year').val(location.pathname.replace('index.html', ''));

				// 選択した年に飛ばす
				$('.js-news-select-year').change(function(){
					location.href = $(this).val();
				});
			}

		},
		setHeaderHeight() {
			if (!$('.top-important-wrap').length) {
				$('.container').addClass('__no_important')
			}
		},
		fileSizeEx() {
			const setFileSize = (className) => {
				// console.log(className);
				if ($(className).length) {
					$(className).each(function () {
						$(this).text(bytesToSize($(this).text()));
					});
				}
				function bytesToSize(bytes) {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return '（' + (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i] + '）';
				}
			}
			setFileSize('.rt_cf_n_attachment_file_size');
			setFileSize('.rt_cf_n_attachment_file_sizel');
		},
		loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.scrollEvent();
			_this.modal();
			_this.lazyload();
			_this.setImgAttrWidthHeight();
			_this.headerMenu();
			_this.tabSwitch();
			_this.pageTop();
			//_this.headerFixed();
			// _this.headerCurrent();
			// _this.formAnswer();
			// _this.formYear();
			// _this.formReset();
			// _this.formConfirm();
			//_this.newsYear();
			// _this.setHeaderHeight();
			//_this.fileSizeEx();
		}
	};

	$(() => DIPUNTO.localDecision() ? DIPUNTO.localLoading() : DIPUNTO.loadDelayScript());
})(window.jQuery);
